module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/168-bulgaria-a1f18f8d346fca2c58426ad1dfc8950a.svg";